module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 11 20",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }